/**
 * DocumentTypes.js
 *
 * Shared utilities
 *  -for managing document options for all roles
 * - formatting document types consistently for displaying document type labels
 */

export const DOCUMENT_OPTIONS = [
  { value: 'manual', label: 'User Manual' },
  { value: 'certificate', label: 'Certificate' },
  { value: 'warranty', label: 'Warranty' },
  { value: 'purchase_order', label: 'Purchase Order' },
  { value: 'maintenance_report', label: 'Maintenance Report' },
  { value: 'calibration_report', label: 'Calibration Report' },
  { value: 'compliance_report', label: 'Compliance Report' },
  { value: 'safety', label: 'Safety Document' },
  { value: 'other', label: 'Other' },
];

export const DOCUMENT_OPTIONS_FOR_TECHNICIAN = [
  { value: 'maintenance_report', label: 'Maintenance Report' },
  { value: 'calibration_report', label: 'Calibration Report' },
  { value: 'compliance_report', label: 'Compliance Report' },
];

/** Complaint-scoped document types (complaint_documents table). */
export const COMPLAINT_DOCUMENT_TYPE_PHOTO = 'complaint_photo';
export const COMPLAINT_DOCUMENT_TYPE_REPORT = 'complaint_report';

export const COMPLAINT_DOCUMENT_OPTIONS = [
  { value: COMPLAINT_DOCUMENT_TYPE_PHOTO, label: 'Complaint Photo' },
  { value: COMPLAINT_DOCUMENT_TYPE_REPORT, label: 'Complaint Report' },
];

/** Upload dropdown options when closing a complaint (complaint report only). */
export const COMPLAINT_CLOSE_UPLOAD_DOCUMENT_OPTIONS = [
  { value: COMPLAINT_DOCUMENT_TYPE_REPORT, label: 'Complaint Report' },
];

/** Multipart work_type value: technician uploads outside strict PPM/CAL/COM maintenance logging. */
export const TECHNICIAN_WORK_TYPE_GENERAL = 'general';

/** Dashboard / modal maintenance kind → device document type for that work (PPM, Calibration, Compliance). */
export const MAINTENANCE_TYPE_TO_REPORT_DOCUMENT_TYPE = {
  PPM: 'maintenance_report',
  Calibration: 'calibration_report',
  Compliance: 'compliance_report',
};

/**
 * Options shown when logging maintenance: only the report type that matches the maintenance category.
 * Unknown maintenanceType falls back to the three report types (no complaint report).
 */
export function getDocumentOptionsForMaintenanceType(maintenanceType) {
  const docValue = MAINTENANCE_TYPE_TO_REPORT_DOCUMENT_TYPE[maintenanceType];
  if (!docValue) {
    return DOCUMENT_OPTIONS_FOR_TECHNICIAN.filter((o) =>
      ['maintenance_report', 'calibration_report', 'compliance_report'].includes(o.value)
    );
  }
  return DOCUMENT_OPTIONS_FOR_TECHNICIAN.filter((o) => o.value === docValue);
}

export const formatDocumentType = (type) => {
    const types = {
      'manual': 'User Manual',
      'certificate': 'Certificate',
      'warranty': 'Warranty',
      'purchase_order': 'Purchase Order',
      'complaint_report': 'Complaint Report',
      'complaint_photo': 'Complaint Photo',
      'maintenance_report': 'Maintenance Report',
      'calibration_report': 'Calibration Report',
      'compliance_report': 'Compliance Report',
      'safety': 'Safety Document',
      'other': 'Other'
    };
    return types[type] || type;
};
